import React from 'react';

import TableUI from '../list/TableUI';

class WidgetList extends React.Component {

  render() {
    return(
      <div className="col-md-6">
        <TableUI 
          data={this.props.table.data} 
          model={this.props.model} 
          fields={this.props.widget.json.fields}
          pagination={{currentPage: 1, perPage: this.props.widget.json.per_page }}
          inApiCall={false} preview={false} update={false} delete={false}
          isFilterOpen={false} />
      </div>
    );
  }
}
export default WidgetList;